import React, { useState, useEffect } from 'react';
import SharedHeaderLayout from '../components/layout/SharedHeaderLayout.jsx';
import background from '../assets/background.webp';
import { apiUrl } from '../config/api.js';

const PrivacyPolicyPage = () => {
    const [content, setContent] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchPolicy = async () => {
            try {
                const response = await fetch(apiUrl('/api/auth/privacy-policy'));
                if (!response.ok) {
                    throw new Error('Failed to load privacy policy');
                }
                const data = await response.json();
                setContent(data);
            } catch (err) {
                console.error('Error loading privacy policy:', err);
                setError(err.message);
            } finally {
                setLoading(false);
            }
        };
        fetchPolicy();
    }, []);

    return (
        <div className="min-h-screen bg-gaia-bg flex flex-col">
            <SharedHeaderLayout />
            <div
                className="flex-grow flex flex-col items-center justify-start relative overflow-auto"
                style={{
                    backgroundImage: `url(${background})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    backgroundRepeat: 'no-repeat',
                    backgroundAttachment: 'fixed'
                }}
            >
                {/* Dark overlay for readability */}
                <div className="absolute inset-0 bg-black/20"></div>

                {/* Main Content */}
                <main className="relative z-10 flex flex-col items-center px-4 py-8 max-w-3xl w-full">
                    <div className="text-center mb-6">
                        <h1
                            className="text-3xl md:text-4xl text-gray-100 drop-shadow-lg tracking-wide font-bold"
                            style={{
                                fontFamily: '"Cinzel", "Times New Roman", serif',
                                textShadow: '0 0 10px rgba(0,0,0,0.9), 2px 2px 4px rgba(0,0,0,0.8)'
                            }}
                        >
                            Privacy Policy
                        </h1>
                    </div>

                    <div
                        className="bg-black/40 backdrop-blur-sm border border-gray-700/50 rounded-lg p-8 shadow-2xl w-full"
                        style={{ maxWidth: 'calc(48rem + 20px)' }}
                    >
                        {loading && (
                            <div className="flex justify-center py-8">
                                <div className="animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-gaia-primary"></div>
                            </div>
                        )}
                        {error && (
                            <p
                                className="text-red-400 text-center"
                                style={{ fontFamily: '"Times New Roman", Georgia, serif' }}
                            >
                                {error}
                            </p>
                        )}
                        {content && (
                            <pre
                                className="text-base md:text-lg text-gray-200 leading-relaxed whitespace-pre-wrap"
                                style={{
                                    fontFamily: '"Times New Roman", Georgia, serif',
                                    textShadow: '0 0 10px rgba(0,0,0,0.9), 1px 1px 2px rgba(0,0,0,0.8)'
                                }}
                            >
                                {content.content}
                            </pre>
                        )}
                    </div>
                </main>
            </div>
        </div>
    );
};

export default PrivacyPolicyPage;
